import { computed, resolveComponent, openBlock, createElementBlock, normalizeClass, createCommentVNode, createElementVNode, createBlock, renderSlot } from 'vue';
import { createComponent } from './utils/create-component';
import { CLICK_EVENT, DISABLED_CLICK_EVENT } from './utils/constants';
import propTypes from './utils/prop-types';
import Icon from './icon';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

// 按钮大小定义
var sizes = ['tiny', 'mini', 'small', 'medium', 'large', 'huge'];
var defaultSize = sizes[3];
// 按钮类型定义
var types = ['primary', 'plain'];
var defaultType = types[0];

var props = {
  /**
   * kid token
   */
  token: propTypes.string(),
  /**
   * 按钮类型
   */
  type: propTypes.string().def(defaultType),
  /**
   * 按钮大小
   */
  size: propTypes.string().def(defaultSize),
  /**
   * 幽灵（线型）按钮
   */
  ghost: propTypes["boolean"]().def(false),
  /**
   * 按钮禁用
   */
  disabled: propTypes["boolean"]().def(false),
  /**
   * 自适应宽度（100%宽度）
   */
  fit: propTypes["boolean"]().def(false),
  /**
   * 内置icon
   */
  icon: propTypes.string(),
  /**
   * 原生按钮类型
   */
  nativeType: propTypes.string().def('button')
};
var emits = [CLICK_EVENT, DISABLED_CLICK_EVENT];

var _createComponent = createComponent('button'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  components: _defineProperty({}, Icon.name, Icon),
  props: props,
  emits: emits,
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    // 对错误的属性进行纠错
    var type = computed(function () {
      return types.includes(props.type) ? props.type : defaultType;
    });
    var size = computed(function () {
      return sizes.includes(props.size) ? props.size : defaultSize;
    });
    var token = props.token;
    var buttonClassNames = computed(function () {
      var ghost = props.ghost,
        disabled = props.disabled,
        fit = props.fit;
      return [className, _defineProperty({}, "".concat(token, "__button"), !!token), ghost ? "".concat(className, "__").concat(type.value, "-ghost") : "".concat(className, "__").concat(type.value), "".concat(className, "__").concat(size.value), _defineProperty({}, "".concat(className, "-disabled"), disabled), _defineProperty({}, "".concat(className, "-fit"), fit)];
    });
    var textClassNames = token ? "".concat(className, "__text ").concat(token, "__text") : "".concat(className, "__text");
    var iconClassNames = "".concat(className, "__icon");
    /**
     * 按钮事件抛出，禁用按钮也需要抛出事件
     */
    function handleClick(e) {
      if (props.disabled) {
        emit(DISABLED_CLICK_EVENT, e);
        return;
      }
      emit(CLICK_EVENT, e);
    }
    return {
      className: className,
      buttonClassNames: buttonClassNames,
      textClassNames: textClassNames,
      iconClassNames: iconClassNames,
      handleClick: handleClick
    };
  }
});

var _hoisted_1 = ["type"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_icon = resolveComponent("sp-icon");
  return openBlock(), createElementBlock("button", {
    "class": normalizeClass(_ctx.buttonClassNames),
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.handleClick && _ctx.handleClick.apply(_ctx, arguments);
    }),
    type: _ctx.nativeType
  }, [createCommentVNode(" 在ios10上button元素不能设置display:flex "), createElementVNode("div", {
    "class": normalizeClass("".concat(_ctx.className, "__content"))
  }, [createCommentVNode(" 内置icon组件 "), _ctx.icon ? (openBlock(), createBlock(_component_sp_icon, {
    key: 0,
    name: _ctx.icon,
    "class": normalizeClass(_ctx.iconClassNames)
  }, null, 8 /* PROPS */, ["name", "class"])) : createCommentVNode("v-if", true), createCommentVNode(" 通过slot传入自定义icon或图片 "), renderSlot(_ctx.$slots, "icon"), createCommentVNode(" 按钮内容 "), createElementVNode("div", {
    "class": normalizeClass(_ctx.textClassNames)
  }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */)], 2 /* CLASS */)], 10 /* CLASS, PROPS */, _hoisted_1);
}

script.render = render;
script.__file = "components/src/component/button/button.vue";

var _Button = script;

export { _Button as default };
